module.exports = __webpack_public_path__ + "37243bd0c3cd8aa230b1c88fd669974e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/copy.svg
// module id = 743
// module chunks = 0